module.exports = __webpack_public_path__ + "static/assets/74b3997c5bfd398fe769d5a32da89b56.svg";